import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "EmptyAllReviewedMessage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "MessageContainer" }, [
      _createElementVNode("img", {
        src: "https://monet-prtl-co.imgix.net/Endor/ERT/empty-all-reviewed.svg",
        class: "EmptyImage"
      }),
      _createElementVNode("p", null, "You seem to have reviewed everything. Great job! 👍")
    ], -1 /* CACHED */)
  ]))]))
}